import { render } from "./IInput.vue?vue&type=template&id=13fc08bd"
import script from "./IInput.vue?vue&type=script&lang=js"
export * from "./IInput.vue?vue&type=script&lang=js"

import exportComponent from "/Users/ilya/Documents/Web/github/iTunes-Vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__